import React from 'react';

const DutchFlag = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 900 600" xmlns="http://www.w3.org/2000/svg">
      <rect width="900" height="600" fill="#fff"/>
      <rect width="900" height="200" fill="#AE1C28"/>
      <rect width="900" height="200" fill="#21468B" y="400"/>
    </svg>
  );
};

export default DutchFlag;